import { useNavigate } from 'react-router-dom';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import DialogContent from '@zenbusiness/zui/DialogContent';

import * as ROUTES from '#client/constants/routes';

import * as Styled from './ContactCS.style';

import { useChangeRequestContext, useSetChangeRequest } from '../hooks/useChangeRequestContext';

export default function ContactCS() {
  const { changeFlow } = useChangeRequestContext();
  const { setChangeFlow } = useSetChangeRequest();
  const navigate = useNavigate();

  const { modalFlow } = changeFlow;
  const { restartSubscription, changeBillingIntervalAnnual } = modalFlow;

  const handleContactCS = () => {
    navigate(ROUTES.help);
  };

  const handleNotNow = () => {
    setChangeFlow((prevState) => ({
      ...prevState,
      modalFlow: {
        ...modalFlow,
        error: false,
        restartSubscription: {
          ...restartSubscription,
          start: false,
        },
        changeBillingIntervalAnnual: {
          ...changeBillingIntervalAnnual,
          start: false,
        },
      },
    }));
  };

  return (
    <>
      <DialogContent>
        <Box textAlign="center" py={2}>
          <Styled.ContactCSErrorIcon />
          <Styled.TitleText size="xl" weight="bold" align="center">
            <FormattedMessage id="dashboard.subscriptions.contactCS.title" />
          </Styled.TitleText>
        </Box>
      </DialogContent>
      <Styled.ActionsContainer>
        <Button
          fullWidth
          variant="contained"
          onClick={handleContactCS}
          clickstreamProps={{ elementName: 'contact_customer_service' }}
        >
          <FormattedMessage id="dashboard.subscriptions.contactCS.contactButton" />
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={handleNotNow}
          clickstreamProps={{ elementName: 'contact_cs_not_now' }}
        >
          <FormattedMessage id="dashboard.subscriptions.contactCS.notNow" />
        </Button>
      </Styled.ActionsContainer>
    </>
  );
}
